import React from "react";

const ScreenTitleIcon = ({ size = 24, color = '#000' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.4">
        <path
          d="M10 12.5V18.3333"
          stroke="#292D32"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.66602 18.3334H13.3327"
          stroke="#292D32"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <path
        d="M4.82517 12.2416H15.1752C16.5585 12.2416 17.3918 11.15 17.0335 9.81663L15.2002 3.09163C14.9835 2.30829 14.1418 1.66663 13.3418 1.66663H6.65851C5.85851 1.66663 5.01684 2.30829 4.80851 3.08329L2.97517 9.80829C2.60851 11.15 3.44184 12.2416 4.82517 12.2416Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default ScreenTitleIcon;
